<div class="confirm-dialog">
    <div class="d-flex align-items-center justify-content-end p-3">
      <i class="ri-close-line cursor-pointer icon-lg icon-default" (click)="onNoClick()"></i>
    </div>
    <div class="p-4 text-center">
      <h3>{{ data.title | translate }}</h3>
      <p>{{ data.message | translate }}</p>
      
      <div class="d-flex justify-content-center gap-3 mt-4">
        <button class="cancel_btn dialog-button" (click)="onNoClick()">
          {{ 'Shared.CANCEL' | translate }}
        </button>
        <button class="primary-btn dialog-button" (click)="onYesClick()">
          {{ 'Shared.CONFIRM' | translate }}
        </button>
      </div>
    </div>
  </div>